import { checkExpiryDateTimestamp } from './common';
import { BannerEntity } from '../types';

export const getFrame = (
  tags: string[],
  frames: BannerEntity[],
): string | undefined => {
  const ids: number[] = [];
  tags.forEach((el) => {
    const matchReg = el.match(/^frame_(\d+)_.+/);
    if (matchReg && matchReg[1] && !isNaN(parseInt(matchReg[1]))) {
      ids.push(parseInt(matchReg[1]));
    }
  });
  const frame = frames.find(
    (fr) =>
      ids.includes(parseInt(fr.id)) &&
      fr.startDate &&
      fr.endDate &&
      checkExpiryDateTimestamp(fr.startDate, fr.endDate),
  );
  return frame ? frame.image : undefined;
};

export const isVariantUrlGrouped = (canonical: string) => {
  // some product need to group all skus into a single url
  // we don't have that flag returned to client
  // so rely on url pattern for now, which may not be
  // very reliable in the future
  // for such product, canonical is /product-name--p<productId>
  return canonical?.indexOf('--p') >= 0;
};
